import { Stack, Typography } from '@mui/material'
import FilterRange from 'components/FilterRange/FilterRange'
import FilterSelect from 'components/FilterSelect/FilterSelect'
import FilterCheckbox from 'components/FilterCheckbox/FilterCheckbox'

function CollapseFilterItem({ filter, query, setQuery }) {
  return (
    <Stack spacing={0.8} sx={{ py: '1.6rem' }}>
      <Typography sx={{ opacity: 0.6 }}>{filter.label}</Typography>

      {filter.type === 'range' ? (
        <FilterRange filter={filter} query={query} setQuery={setQuery} />
      ) : null}
      {filter.type === 'select' ? (
        <FilterSelect filter={filter} query={query} setQuery={setQuery} />
      ) : null}
      {filter.type === 'checkbox' ? (
        <FilterCheckbox filter={filter} query={query} setQuery={setQuery} />
      ) : null}
    </Stack>
  )
}

export default CollapseFilterItem
